export default __webpack_public_path__ + "apply5aa1385.png";